import TagManager from 'react-gtm-module';

interface TrackStoreInteractionProps {
  data: {
    linkUrl: string | null;
    linkText: string;
  };
}

export const trackStoreInteraction = ({ data }: TrackStoreInteractionProps) => {
  const { linkUrl, linkText } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_store_interaction',
      interaction: {
        link_url: linkUrl ?? null,
        link_text: linkText,
      },
    },
  });
};

interface TrackDeliveryOptionInteractionProps {
  data: {
    deliveryOption: string;
  };
}

export const trackDeliveryOptionInteraction = ({
  data,
}: TrackDeliveryOptionInteractionProps) => {
  const { deliveryOption } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'select_delivery_option_pdp',
      interaction: {
        delivery_option: deliveryOption,
      },
    },
  });
};

interface TrackSelectStoreInteractionProps {
  data: {
    interactionLocation: string;
    storeName: string;
  };
}

export const trackSelectStoreInteraction = ({
  data,
}: TrackSelectStoreInteractionProps) => {
  const { interactionLocation, storeName } = data;

  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'select_store',
      interaction: {
        interaction_location: interactionLocation,
        store_name: storeName,
      },
    },
  });
};
